export const bingKey =
  'AvMMCjv1m2WG02X0xGvdFAG0YUpIkf-t_f2WAU0X_WMDUm-ZrV9ZoQPxgM5FvFx0';
  
export const basePath = 'https://portales.planbsys.com/gpmetwebportal/api';
